import React, { useState } from "react";
import { View, TouchableOpacity, ScrollView } from "react-native";
import * as Clipboard from "expo-clipboard";
import { Button } from "../Button/Button";
import { Heading } from "../Heading/Heading";
import { Icon } from "../Icon/Icon";
import { Message } from "../Message/Message";
import { Panel } from "../Panel/Panel";
import { Text } from "../Text/Text";
import { styles } from "./DefaultErrorComponent.styles";
export const DefaultErrorComponent = ({ message, children, basicMessage = "An error occured", styles: userStyles, onRetry, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isCopied, setIsCopied] = useState(false);
    return (React.createElement(Panel, { testID: "DefaultErrorBoundary", color: "negative", styles: [styles.panel, userStyles] },
        React.createElement(Heading, { styles: styles.heading, color: "light.base", fontSize: "xlarge", level: 1 }, basicMessage),
        React.createElement(View, { style: styles.detailsContainer },
            React.createElement(View, { style: styles.detailsToggleWrapper },
                React.createElement(TouchableOpacity, { onPress: () => setIsOpen(!isOpen), style: styles.toggleContainer },
                    React.createElement(Icon.DoubleChevron, { size: "small", color: "light.base", style: {
                            transform: isOpen
                                ? [{ rotate: "90deg" }]
                                : [{ rotate: "0deg" }],
                        } }),
                    React.createElement(Text, { color: "light.base", styles: styles.detailsHeading }, "Details")),
                isOpen && (React.createElement(View, { style: styles.clipboardWrapper },
                    React.createElement(React.Fragment, null,
                        isCopied && (React.createElement(Message, { styles: styles.clipboardMessage, type: "success", small: true, color: "light" }, "Copied")),
                        React.createElement(TouchableOpacity, { onPress: async () => {
                                await Clipboard.setStringAsync(message ?? children ?? "");
                                setIsCopied(true);
                            } },
                            React.createElement(Icon.Clipboard, { size: "medium", color: "light.base" })))))),
            isOpen && (React.createElement(Panel, { styles: styles.errorStack },
                React.createElement(ScrollView, null,
                    React.createElement(Text, { style: styles.errorStackMessage, fontSize: "xsmall" }, message ?? children))))),
        onRetry && (React.createElement(Button, { color: "warning", size: "small", onPress: () => {
                onRetry();
            } },
            React.createElement(Text, null,
                React.createElement(Icon.Undo, { size: "small", color: "dark.base", style: styles.retryIcon }),
                "Retry")))));
};
//# sourceMappingURL=DefaultErrorComponent.js.map